// extracted by mini-css-extract-plugin
module.exports = {"button":"CardFavouriteBtn_button___ho_2","iconContainer":"CardFavouriteBtn_iconContainer__8TfvP","icon":"CardFavouriteBtn_icon__ZrJes"};